/** Map pins for bloom / harvest layers */
export type BloomMapCategory = 'trees' | 'flowers' | 'crops';

export interface BloomMapPin {
  id: string;
  lat: number;
  lng: number;
  title: string;
  description: string;
  category: BloomMapCategory;
}

export const BLOOM_MAP_PINS: BloomMapPin[] = [
  {
    id: 'cherry-japan',
    category: 'trees',
    lat: 35.685,
    lng: 139.752,
    title: 'Cherry blossoms — Japan',
    description: 'Sakura season (approx Mar–Apr).',
  },
  {
    id: 'cherry-dc',
    category: 'trees',
    lat: 38.8895,
    lng: -77.0353,
    title: 'Cherry blossoms — DC',
    description: 'Tidal Basin peak (approx Mar–Apr).',
  },
  {
    id: 'wisteria-japan',
    category: 'trees',
    lat: 36.333,
    lng: 139.183,
    title: 'Wisteria — Ashikaga',
    description: 'Great wisteria; late Apr–May.',
  },
  {
    id: 'daffodils-uk',
    category: 'flowers',
    lat: 51.1789,
    lng: -0.008,
    title: 'Daffodils — UK',
    description: 'Woodland & gardens; Mar–Apr.',
  },
  {
    id: 'bluebells-uk',
    category: 'flowers',
    lat: 51.06,
    lng: -0.09,
    title: 'Bluebells — UK',
    description: 'Ancient woodlands; Apr–May.',
  },
  {
    id: 'lavender-provence',
    category: 'flowers',
    lat: 43.92,
    lng: 6.07,
    title: 'Lavender — Provence',
    description: 'Valensole plateau; Jun–Jul.',
  },
  {
    id: 'peony-ny',
    category: 'flowers',
    lat: 40.7829,
    lng: -73.9654,
    title: 'Peonies — NYC',
    description: 'Botanical & gardens; May–Jun.',
  },
  {
    id: 'tulip-amsterdam',
    category: 'flowers',
    lat: 52.377,
    lng: 4.894,
    title: 'Tulips — Amsterdam',
    description: 'City & Keukenhof season; Apr–May.',
  },
  {
    id: 'tulip-nl',
    category: 'crops',
    lat: 52.27,
    lng: 4.55,
    title: 'Tulip fields — Netherlands',
    description: 'Commercial fields; mid Apr peak.',
  },
  {
    id: 'sunflowers-tuscany',
    category: 'crops',
    lat: 43.32,
    lng: 11.33,
    title: 'Sunflowers — Tuscany',
    description: 'Jul–Aug rows.',
  },
];
